import jwtDecode from 'jwt-decode'
import Cookies from 'js-cookie'

type JwtPayload = {
  exp?: number
  nbf?: number
  [key: string]: any
}

/**
 * Validates the JWT by checking `exp` and `nbf` claims.
 * Optionally auto-clears the cookie if expired.
 */
export function isJwtValid(token?: string, clearIfInvalid = false): boolean {
  try {
    token = token || Cookies.get('token')
    if (!token) return false

    const decoded: JwtPayload = jwtDecode(token)
    const now = Math.floor(Date.now() / 1000)

    if (decoded.exp && decoded.exp < now) {
      if (clearIfInvalid) Cookies.remove('token')
      return false
    }

    if (decoded.nbf && decoded.nbf > now) {
      if (clearIfInvalid) Cookies.remove('token')
      return false
    }

    return true
  } catch (e) {
    if (clearIfInvalid) Cookies.remove('token')
    return false
  }
}
